export default __webpack_public_path__ + "static/media/Ballroll_00300.c762fecf.png";